// extracted by mini-css-extract-plugin
export default {"divider":"wiYJ2dmwes_landings","horizontal":"Px7cWdK1WX_landings","line":"SSUaVPr8GZ_landings","dashed":"B68jm_yw0p_landings","vertical":"CDJt29Umcr_landings"};